import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  FacebookShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
} from 'react-share';

import ShareUrlClipboardButton from './ShareUrlClipboardButton';

const propTypes = {
  className: PropTypes.string,
  url: PropTypes.string.isRequired,
  quote: PropTypes.string,
  hashtag: PropTypes.string,
};

const ShareUrlIcons = ({ className, url, hashtag, quote }) => {
  const classes = classNames({
    'share-url-icons': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <ShareUrlClipboardButton
        className="share-url-icon-btn share-url-icon-btn-clipboard"
        text={`${quote} ${url}`.trim()}
      />

      <FacebookShareButton
        quote={quote}
        url={url}
        hashtag={hashtag}
        className="share-url-icon-btn share-url-icon-btn-facebook"
      >
        <FacebookIcon size={52} />
      </FacebookShareButton>

      <TwitterShareButton
        url={url}
        hashtags={[hashtag]}
        title={quote}
        via="waldophotos"
        className="share-url-icon-btn share-url-icon-btn-twitter"
      >
        <TwitterIcon size={52} />
      </TwitterShareButton>
    </div>
  );
};

ShareUrlIcons.propTypes = propTypes;

export default ShareUrlIcons;
